var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-attentions" },
    [
      _c(
        "div",
        { staticClass: "filter-header", on: { click: _vm.toggleAccordion } },
        [
          _c("h3", { staticClass: "filter-title" }, [
            _vm._v("Filtrar Atenciones")
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "toggle-btn", class: { "is-open": _vm.isOpen } },
            [
              _c("span", { staticClass: "toggle-icon" }, [
                _vm._v(_vm._s(_vm.isOpen ? "❮" : "+"))
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "accordion" },
          on: {
            "after-enter": _vm.onAfterEnter,
            "before-leave": _vm.onBeforeLeave
          }
        },
        [
          _vm.isOpen
            ? _c("div", { ref: "accordionBody", staticClass: "filter-body" }, [
                _c("div", { staticClass: "filter-mode" }, [
                  _c("label", { staticClass: "radio-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filterMode,
                          expression: "filterMode"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "filterMode",
                        value: "include"
                      },
                      domProps: { checked: _vm._q(_vm.filterMode, "include") },
                      on: {
                        change: function($event) {
                          _vm.filterMode = "include"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Incluir selección")])
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "radio-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filterMode,
                          expression: "filterMode"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        name: "filterMode",
                        value: "exclude"
                      },
                      domProps: { checked: _vm._q(_vm.filterMode, "exclude") },
                      on: {
                        change: function($event) {
                          _vm.filterMode = "exclude"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Excluir selección")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-selectors" },
                  [
                    _c("selector-group", {
                      attrs: {
                        label: "Categoría de atención",
                        "pill-class": "pill--category",
                        options: _vm.availableCategories,
                        "selected-items": _vm.selectedCategories
                      },
                      on: {
                        toggle: _vm.toggleCategory,
                        remove: _vm.toggleCategory
                      }
                    }),
                    _vm._v(" "),
                    _c("selector-group", {
                      attrs: {
                        label: "Grupo de atención",
                        "pill-class": "pill--group",
                        options: _vm.availableGroups,
                        "selected-items": _vm.selectedGroups,
                        disabled: _vm.selectedCategories.length === 0
                      },
                      on: { toggle: _vm.toggleGroup, remove: _vm.toggleGroup }
                    }),
                    _vm._v(" "),
                    _c("selector-group", {
                      attrs: {
                        label: "Tipo de atención",
                        "pill-class": "pill--type",
                        options: _vm.availableTypes,
                        "selected-items": _vm.selectedTypes,
                        disabled: _vm.selectedGroups.length === 0
                      },
                      on: { toggle: _vm.toggleType, remove: _vm.toggleType }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "filter-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      on: { click: _vm.applyFilters }
                    },
                    [_vm._v("\n          Aplicar filtros\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary is-outlined",
                      on: { click: _vm.clearFilters }
                    },
                    [_vm._v("\n          Limpiar filtros\n        ")]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }